import React, { useState, useEffect, useRef } from 'react';
import { wrapFunctionalComponent } from 'utils/framework';
import {
    Text, Box, Divider, Grid
} from 'components/ui';
import ProductTableItem from 'components/ProductPage/ProductTable/ProductTableItem/ProductTableItem';
import { space, site } from 'style/config';

const getComparisonSku = (currentSku, productDetails, comparisonSkuHighlights) => ({
    skuId: currentSku?.skuId,
    skuImages: currentSku?.skuImages,
    size: currentSku?.size,
    brandName: productDetails?.brand?.displayName,
    productName: productDetails?.displayName,
    highlights: comparisonSkuHighlights,
    listPrice: currentSku?.listPrice,
    salePrice: currentSku?.salePrice,
    valuePrice: currentSku?.valuePrice,
    productId: productDetails?.productId,
    targetUrl: currentSku?.targetUrl,
    starRatings: productDetails?.rating,
    productReviewCount: productDetails?.reviews
});

const ProductTable = ({
    podId, skuList, currentProduct, title, resultId, totalResults, isCarousel
}) => {
    const [recommendedSkus, setRecommendedSkus] = useState([]);
    const [recommendedTitle, setRecommendedTitle] = useState('');
    const scrollRef = useRef(null);

    useEffect(() => {
        if (podId && skuList) {
            const { currentSku, productDetails } = currentProduct;
            const comparisonSkuHighlights = currentSku?.highlights?.map(highlight => highlight.name);
            const comparisonSku = getComparisonSku(currentSku, productDetails, comparisonSkuHighlights);
            const skus = [null, comparisonSku, ...skuList];
            setRecommendedSkus(skus);
            setRecommendedTitle(title);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [skuList]);

    useEffect(() => {
        if (scrollRef.current) {
            scrollRef.current.scrollLeft = 0;
        }
    }, [recommendedSkus]);

    return recommendedSkus?.length ? (
        <Box
            lineHeight='tight'
            marginBottom={[6, 7]}
        >
            <Divider />
            <Text
                is='h2'
                marginY='1em'
                fontSize={['md', 'lg']}
                fontWeight='bold'
                children={recommendedTitle}
            />
            <Grid
                ref={scrollRef}
                columns={`${space.container}px 98px repeat(6, ${(site.containerMax - 98) / 6}px)`}
                fontSize={['sm', 'base']}
                gap={null}
                marginX='-container'
                paddingRight='container'
                css={{
                    overflow: 'auto',
                    scrollBehavior: 'smooth',
                    scrollbarWidth: 'none',
                    overscrollBehaviorX: 'none',
                    scrollSnapType: 'x mandatory',
                    '&::-webkit-scrollbar': { display: 'none' },
                    '& > *': {
                        scrollSnapAlign: 'start'
                    }
                }}
                data-cnstrc-recommendations
                data-cnstrc-recommendations-pod-id={podId}
                data-cnstrc-result-id={resultId}
                data-cnstrc-num-results={totalResults}
            >
                <div />
                {recommendedSkus.map((sku, index) => (
                    <ProductTableItem
                        key={`carouselBasketItem_${index}_${sku?.skuId || 'label'}`}
                        sku={sku}
                        index={index}
                        podId={podId}
                        isCarousel={isCarousel}
                    />
                ))}
            </Grid>
        </Box>
    ) : null;
};

export default wrapFunctionalComponent(ProductTable, 'ProductTable');
